import { render, staticRenderFns } from "./tomooni.vue?vue&type=template&id=e7b3b958"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7b3b958')) {
      api.createRecord('e7b3b958', component.options)
    } else {
      api.reload('e7b3b958', component.options)
    }
    module.hot.accept("./tomooni.vue?vue&type=template&id=e7b3b958", function () {
      api.rerender('e7b3b958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/new/tomooni.vue"
export default component.exports